import TeamsImg from '@assets/images/video-tutorial/teams.png'
import { VideoTutorial } from '@components/VideoTutorial'
import { useVideoTutorial } from '@components/VideoTutorial/useVideoTutorial'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

export const TeamSpaceTutorial: React.FC = () => {
  const { createTeamId, handleViewedTutorial } = useVideoTutorial()

  if (!createTeamId) {
    return null
  }

  const handleLinkClick = () => {
    handleViewedTutorial(createTeamId)
    sendGtmEvent(GtmTriggerName.TEAMS_INTRO)
  }

  const handleCloseClick = () => {
    handleViewedTutorial(createTeamId)
  }

  return (
    <div className={css.video_tutorial_wrap}>
      <VideoTutorial
        title="Welcome to Teams"
        description="Explore advanced features we tailor for teams"
        img={TeamsImg}
        link="https://youtu.be/1_1taoCRj6k?si=BWQiuIT_wez9OXJX"
        position="top-center"
        onLinkClick={handleLinkClick}
        onCloseClick={handleCloseClick}
      />
    </div>
  )
}
